import { render, staticRenderFns } from "./VideoHero.vue?vue&type=template&id=5740bd06&scoped=true"
import script from "./VideoHero.vue?vue&type=script&lang=js"
export * from "./VideoHero.vue?vue&type=script&lang=js"
import style0 from "./VideoHero.vue?vue&type=style&index=0&id=5740bd06&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5740bd06",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/vercel/path0/components/elements/Video.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
